import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { QuillLogo } from "../components/QuillLogo";
import { OutlineLink } from "../components/OutlineLink";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem("rq_admin_token", data.access_token);
      navigate("/admin/enquiries");
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Unable to sign in. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const inputClass =
    "w-full border-0 border-b border-[#A8A296] bg-transparent py-3 text-[16px] outline-none transition-colors focus:border-[#7A2E2E] text-[#1C1A17] placeholder:text-[#6E6A5E] rounded-none";

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#F4F1EA] px-6" data-testid="admin-login-page">
      <div className="w-full max-w-[420px]">
        <div className="flex flex-col items-center mb-12">
          <QuillLogo height={72} />
          <p className="mt-6 text-[11px] uppercase tracking-[0.3em] text-[#7A2E2E]">
            The Archive
          </p>
          <hr className="mt-4 border-0" style={{ width: "72px", height: "0.75px", backgroundColor: "#7A2E2E" }} />
          <h1 className="mt-6 text-[24px] italic text-[#1C1A17]">Enquiries</h1>
        </div>

        <form onSubmit={onSubmit} className="space-y-8" data-testid="admin-login-form">
          <div>
            <label className="block text-[11px] uppercase tracking-[0.28em] text-[#7A2E2E] mb-3" htmlFor="admin-email">
              Email
            </label>
            <input
              id="admin-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={inputClass}
              data-testid="admin-email-input"
            />
          </div>
          <div>
            <label className="block text-[11px] uppercase tracking-[0.28em] text-[#7A2E2E] mb-3" htmlFor="admin-password">
              Password
            </label>
            <input
              id="admin-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className={inputClass}
              data-testid="admin-password-input"
            />
          </div>

          {error && (
            <p className="text-[14px] italic text-[#7A2E2E]" data-testid="admin-login-error">
              {error}
            </p>
          )}

          <div className="pt-2">
            <OutlineLink as="button" type="submit" testid="admin-login-submit">
              {loading ? "Signing in" : "Enter"}
            </OutlineLink>
          </div>
        </form>

        <div className="mt-12 text-center">
          <Link
            to="/"
            data-testid="admin-back-to-site"
            className="inline-block text-[10px] uppercase tracking-[0.3em] text-[#6E6A5E] transition-colors hover:text-[#7A2E2E]"
          >
            Return to the Website
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
